import {
  FlightInfo,
  GetPackagesShowResponse,
  PackageDepartureHotelImage,
  PackageDepartureRoomInfo,
  PackageDepartureRoomInfoImage,
} from '@lt/api/dist/methods/packages/types';

export type PackagePreloadedState = {
  package_id: number;
  /** дата последней загрузки данных,
   * устанавливается при инициализации виджета и далее не меняется*/
  lastPriceUpdateDate: Date;
  /** перелет для отображения */
  flight_option?: FlightInfo;
  /** сколько еще есть вариантов перелета */
  moreFlightsOptionsCount: number;
};

export type PackageContextState = PackagePreloadedState & {
  package: Pick<
    GetPackagesShowResponse,
    | 'id'
    | 'archived_at'
    | 'labels'
    | 'manual'
    | 'dates_info'
    | 'adults_count'
    | 'kids_ages'
    | 'kids_count'
    | 'search_type'
    | 'price'
    | 'net_price'
    | 'previous_price'
    | 'instant_confirm'
    | 'medical_insurance'
    | 'transfer'
    | 'pansion_description'
    | 'pansion'
    | 'pansion_original'
  > & {
    hotel: Omit<GetPackagesShowResponse['hotel'], 'images'> & {
      images: Partial<PackageDepartureHotelImage>[];
    };
    room_info: Pick<PackageDepartureRoomInfo, 'name_ru'> & {
      images: Partial<PackageDepartureRoomInfoImage>[];
    };
  };
};

export const CONTAINER_QUERY_BREAKPOINTS = {
  minLg: 992,
  minMd: 850,
  minSm: 768,
  minXs: 500,
} as const;
